import { Price } from '~/Api/User/DatasourceComputedPrice';

import ActionTypes from './ActionTypes';

export interface State {
	request: Promise<any> | null;
	userId: string | null;
	prices: { [key: string]: Price[] } | null;
	isFetching: boolean;
}

type Action =
	| {
			type: ActionTypes.request;
			userId: string;
			request: Promise<any> | null;
	  }
	| {
			type: ActionTypes.receive;
			request: Promise<any> | null;
			prices: { [key: string]: Price[] } | null;
	  };

function createState(): State {
	return {
		request: null,
		userId: null,
		prices: null,
		isFetching: false,
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.request:
			return {
				...state,
				userId: action.userId,
				request: action.request,
				isFetching: true,
			};

		case ActionTypes.receive:
			return state.request === action.request
				? {
						...state,
						request: action.prices ? action.request : null,
						prices: action.prices,
						isFetching: false,
				  }
				: state;

		default:
			return state;
	}
}

export function selectPrice(state: State, userId: string | null, calculationType: string): Price | null {
	const { prices } = state;
	if (!userId || !prices) {
		return null;
	}

	let result: Price | null = null;
	Object.values(prices).find((prices: Price[]) => {
		const price = prices.find((candidatePrice) => candidatePrice.calculationType === calculationType);
		if (price) {
			result = price;
			return true;
		}
		return false;
	});

	return result;
}
